import { getContrastRatio, getLuminance } from '@mui/material';
import { Brand } from '@whiz-cart/node-shared/models/brand/brand';
import { maxBy } from 'lodash';

const minimumAccentContrastRatio = 3;

export function getNavigationColors(palette: Brand['palette']) {
    const { navigationBackground, primary } = palette;
    const background = navigationBackground?.main;
    if (!background) {
        return { logo: 'logoWhite' as const };
    }

    const isDarkBackground = getLuminance(background) < 0.5;
    const accentCandidates = [primary?.main, isDarkBackground ? primary?.light : primary?.dark].filter((color): color is string => !!color);
    const accent =
        accentCandidates.find((color) => getContrastRatio(color, background) >= minimumAccentContrastRatio) ??
        maxBy(accentCandidates, (color) => getContrastRatio(color, background));

    return {
        logo: isDarkBackground ? ('logoWhite' as const) : ('logoBlack' as const),
        accent,
        surface: isDarkBackground ? navigationBackground.light : navigationBackground.dark,
    };
}
